module.exports = __webpack_public_path__ + "img/asset-01.b92ea4f1.svg";